import { StoryData } from '@cinch-nx/data-storyblok'
import { DeliveryStory } from '../storyblok'

export const deliveryFallbackStory: StoryData<DeliveryStory> = {
  alternates: [],
  uuid: '45e321b1-2c2d-4e7b-84a0-bd6dc8b48d35',
  content: {
    SEO: [],
    _uid: '9682cc79-4e07-4f14-8eea-8ea101c80193',
    body: [
      {
        _uid: '933632ba-7eb8-47fd-a67e-489d5762bd76',
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: { level: 2, textAlign: null },
              content: [
                {
                  text: 'Where do we deliver?',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: null },
              content: [
                {
                  text: 'We offer home delivery to mainland Great Britain and the Isle of Wight postcodes. Pick a delivery slot, Monday to Saturday, and we’ll deliver your car to your door.',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: null },
              content: [
                {
                  text: 'We don’t deliver to Northern Ireland, the Scottish Islands, the Isles of Scilly, the Isle of Man, Jersey, Guernsey and the other Channel Islands. We also reserve the right not to deliver to certain addresses due to vehicle access limitations.',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: null },
              content: [{ type: 'hard_break' }],
            },
          ],
        },
        component: 'RichText',
        _editable:
          '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "933632ba-7eb8-47fd-a67e-489d5762bd76", "id": "164412505030940"}--\u003E',
      },
      {
        _uid: 'b3506030-7098-4bfc-a18e-37c002dfc957',
        body: 'Body',
        title: 'Title',
        component: 'TextInlineImageSection',
        textInlineImages: [
          {
            _uid: '8a6efc5a-7bb4-4096-a13a-613079b42408',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: { level: 2, textAlign: null },
                  content: [
                    {
                      text: 'Behind the scenes',
                      type: 'text',
                      marks: [{ type: 'bold' }],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: { textAlign: null },
                  content: [
                    {
                      text: 'When you click ‘buy’ our experts kick into gear. Our logistics team get your car prepped and fully valeted, so it’s tip top and ready for you. Then a vehicle handover specialist collects your car and personally delivers it to your door.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: { textAlign: null },
                  content: [{ type: 'hard_break' }],
                },
              ],
            },
            image: {
              id: '164414107571820',
              alt: 'A large brand sign for Cinch on the side of a building',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/768x983/bb31fea7a7/behind-the-scenes.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A large brand sign for Cinch on the side of a building',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'TextInlineImageCard',
            headingLogo: 'cinchCharge',
            imagePosition: 'left',
            headingLeftText: 'Test',
            headingRightText: 'test',
            _editable:
              '\u003C!--#storyblok#{"name": "TextInlineImageCard", "space": "143588", "uid": "8a6efc5a-7bb4-4096-a13a-613079b42408", "id": "164412505030940"}--\u003E',
          },
          {
            _uid: '6f04b98e-d3b1-48ef-a068-8d3d06870d16',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: { level: 2, textAlign: null },
                  content: [
                    {
                      text: 'The delivery day',
                      type: 'text',
                      marks: [{ type: 'bold' }],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: { textAlign: null },
                  content: [
                    {
                      text: 'On delivery day, a vehicle handover specialist will be in touch to let you know they’re on the way. When they drop off your new car, they’ll take time to show you how everything works, explain any technical bits and check everything’s in order. And when it’s all signed for, they’ll hand over the keys. Simple!',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            image: {
              id: '164414107584109',
              alt: 'Picture of a cinch employee handing over a car to a customer.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/834x1067/1228061306/person-handing-over-car.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Picture of a cinch employee handing over a car to a customer.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'TextInlineImageCard',
            headingLogo: '',
            imagePosition: 'right',
            headingLeftText: '',
            headingRightText: '',
            _editable:
              '\u003C!--#storyblok#{"name": "TextInlineImageCard", "space": "143588", "uid": "6f04b98e-d3b1-48ef-a068-8d3d06870d16", "id": "164412505030940"}--\u003E',
          },
        ],
        _editable:
          '\u003C!--#storyblok#{"name": "TextInlineImageSection", "space": "143588", "uid": "b3506030-7098-4bfc-a18e-37c002dfc957", "id": "164412505030940"}--\u003E',
      },
      {
        _uid: 'f362aea5-e8f9-49ba-b8c9-62d4af311b35',
        text: 'Meet a cinch handover specialist at a collection location near you.',
        image: [
          {
            alt: '',
            _uid: '55162d55-7fc3-4496-b071-5c97d582ae8a',
            image: {
              id: '164414108145263',
              alt: "Picture of an employee assisting a customer with a car's controls.",
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/2121x1414/ed3618a00b/person-collecting-car.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: "Picture of an employee assisting a customer with a car's controls.",
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'Image',
            _editable:
              '\u003C!--#storyblok#{"name": "Image", "space": "143588", "uid": "55162d55-7fc3-4496-b071-5c97d582ae8a", "id": "164412505030940"}--\u003E',
          },
        ],
        heading: 'Prefer collection?',
        iconName: 'home-delivery',
        component: 'SectionWithImageV2',
        iconColor: 'goGreen',
        buttonLabel: 'More about collections',
        headingColor: '#8dffbe',
        backgroundColor: '#5234B6',
        _editable:
          '\u003C!--#storyblok#{"name": "SectionWithImageV2", "space": "143588", "uid": "f362aea5-e8f9-49ba-b8c9-62d4af311b35", "id": "164412505030940"}--\u003E',
      },
      {
        _uid: 'e9d71c1e-dd27-4144-bc21-aec57015e0e3',
        title: "After it's yours",
        content: [
          {
            _uid: '48a4af4c-4250-4fb7-bb8d-2775ce0b1860',
            rows: [
              {
                _uid: 'db128462-65fa-48df-b89d-75394c5332a5',
                columns: [
                  {
                    _uid: 'af8d984f-02e6-4723-8d47-2188fce195cc',
                    body: {
                      type: 'doc',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: { textAlign: null },
                          content: [
                            {
                              text: 'To give you that extra peace of mind.',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                    icon: 'our-commitment',
                    title: 'Free 90-day warranty',
                    component: 'FeatureCardV2',
                    _editable:
                      '\u003C!--#storyblok#{"name": "FeatureCardV2", "space": "143588", "uid": "af8d984f-02e6-4723-8d47-2188fce195cc", "id": "164412505030940"}--\u003E',
                  },
                  {
                    _uid: 'cc7d6946-a0d0-4b4b-8531-d83c315e1711',
                    body: {
                      type: 'doc',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: { textAlign: null },
                          content: [
                            {
                              text: 'Protect yourself against the cost of mechanical, electrical and cosmetic repairs with ',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: { color: '#2F2F2F' },
                                },
                              ],
                            },
                            {
                              text: 'cinchCover',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/car-care/cinch-cover',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                { type: 'underline' },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    icon: 'shield-heart',
                    title: 'Cover your car deserves',
                    component: 'FeatureCardV2',
                    _editable:
                      '\u003C!--#storyblok#{"name": "FeatureCardV2", "space": "143588", "uid": "cc7d6946-a0d0-4b4b-8531-d83c315e1711", "id": "164412505030940"}--\u003E',
                  },
                  {
                    _uid: 'bdfd045c-7d74-45b0-ad89-71d43392ea78',
                    body: {
                      type: 'doc',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: { textAlign: null },
                          content: [
                            {
                              text: 'Our ',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: { color: '#2F2F2F' },
                                },
                              ],
                            },
                            {
                              text: '14-day money back guarantee',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/returns',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                { type: 'underline' },
                              ],
                            },
                            {
                              text: ' is there if you change your mind.',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: { color: '#2F2F2F' },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    icon: 'cash',
                    title: 'Money back guarantee',
                    component: 'FeatureCardV2',
                    _editable:
                      '\u003C!--#storyblok#{"name": "FeatureCardV2", "space": "143588", "uid": "bdfd045c-7d74-45b0-ad89-71d43392ea78", "id": "164412505030940"}--\u003E',
                  },
                ],
                component: 'GenericGridRow',
                _editable:
                  '\u003C!--#storyblok#{"name": "GenericGridRow", "space": "143588", "uid": "db128462-65fa-48df-b89d-75394c5332a5", "id": "164412505030940"}--\u003E',
              },
            ],
            component: 'GenericGrid',
            _editable:
              '\u003C!--#storyblok#{"name": "GenericGrid", "space": "143588", "uid": "48a4af4c-4250-4fb7-bb8d-2775ce0b1860", "id": "164412505030940"}--\u003E',
          },
        ],
        component: 'FeatureCardRowWrapper',
        _editable:
          '\u003C!--#storyblok#{"name": "FeatureCardRowWrapper", "space": "143588", "uid": "e9d71c1e-dd27-4144-bc21-aec57015e0e3", "id": "164412505030940"}--\u003E',
      },
      {
        _uid: '9c7b9814-9304-4c4a-b424-7f5892d24c6b',
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: { level: 2, textAlign: null },
              content: [
                {
                  text: 'Part-exchanging your car?',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: null },
              content: [
                {
                  text: 'We make that faff-free too! Your handover specialist will take your part-exchange away when they deliver your cinch car. To make sure it’s good to go, they’ll check:',
                  type: 'text',
                },
              ],
            },
            {
              type: 'bullet_list',
              content: [
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'Your car is roadworthy (e.g. the battery is charged and there’s enough tyre tread)',
                          type: 'text',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        { text: 'Your car has a valid MOT', type: 'text' },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        { text: 'You have any spare keys', type: 'text' },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'Your V5 log book matches the car',
                          type: 'text',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'You’ve removed all your personal belongings',
                          type: 'text',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            { type: 'paragraph', attrs: { textAlign: null } },
          ],
        },
        component: 'RichText',
        _editable:
          '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "9c7b9814-9304-4c4a-b424-7f5892d24c6b", "id": "164412505030940"}--\u003E',
      },
      {
        _uid: 'a6fdd3b1-c8c4-41ff-a445-16acea5efeaf',
        title: 'Let’s find your next car',
        iconName: 'search',
        subtitle: 'Ready to hit the open road?',
        component: 'PreFooterCtaV2',
        buttonLabel: 'Search all cars',
        iconGradient: 'galaxy',
        _editable:
          '\u003C!--#storyblok#{"name": "PreFooterCtaV2", "space": "143588", "uid": "a6fdd3b1-c8c4-41ff-a445-16acea5efeaf", "id": "164412505030940"}--\u003E',
      },
    ],
    hero: [
      {
        _uid: 'eb571c8b-67d2-42d1-9546-6a21f8060036',
        body: 'Your car delivered, when you’re free. Just choose a day and time that suits you, relax, and we’ll do the rest.',
        image: {
          id: '164414107879022',
          alt: 'Picture of a green car with a neon sign of a car being delivered to a house.',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/900x600/3dec3adc10/delivery-hero.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Picture of a green car with a neon sign of a car being delivered to a house.',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        title: 'Home delivery',
        component: 'GenericHero',
        _editable:
          '\u003C!--#storyblok#{"name": "GenericHero", "space": "143588", "uid": "eb571c8b-67d2-42d1-9546-6a21f8060036", "id": "164412505030940"}--\u003E',
      },
    ],
    component: 'LandingPage',
    _editable:
      '\u003C!--#storyblok#{"name": "LandingPage", "space": "143588", "uid": "9682cc79-4e07-4f14-8eea-8ea101c80193", "id": "164412505030940"}--\u003E',
  },
  created_at: '',
  full_slug: '',
  group_id: '',
  id: 0,
  is_startpage: false,
  meta_data: null,
  name: '',
  parent_id: 0,
  position: 0,
  published_at: null,
  first_published_at: null,
  slug: '',
  lang: '',
  sort_by_date: null,
  tag_list: [],
}
